// vg-binding: P7.D-51
// vg-binding: P7.D-134
// vg-binding: P7.D-154
//
// apps/vendor/src/features/payouts/PayoutScheduleCalendar.tsx
//
// Payout schedule card. Rewritten (fix/vendor-batch-e): the original
// hard-coded a fake 15th/last-of-month cadence client-side, which never
// matched reality — payouts are on demand (vendor submits a withdrawal
// request) and new earnings are held for 7/14/21 days based on the vendor
// rating before they become withdrawable. The card now just states that.

import { useTranslation } from '../../lib/i18n/index.js';

export function PayoutScheduleCalendar(): JSX.Element {
  const { t } = useTranslation('wallet');
  return (
    <section
      data-testid="payout-schedule-calendar"
      className="rounded-xl border border-pw-border bg-pw-bg p-5 shadow-sm"
    >
      <h3 className="mb-2 text-sm font-semibold text-pw-text">{t('schedule.title')}</h3>
      <p className="text-xs text-pw-text-muted">
        {t('schedule.description')}
      </p>
      <p className="mt-3 text-sm text-pw-text">
        {t('schedule.holdNote')}
      </p>
    </section>
  );
}

export default PayoutScheduleCalendar;
